import { useEffect, useState } from "react";
import { getGallery } from "@/lib/content";
import { motion } from "framer-motion";
import { Reveal } from "@/components/site/motion";

const FALLBACK = [
  {
    id: "g1",
    after_url: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=1200&q=80&auto=format&fit=crop",
    title: "2 BHK · Whitefield",
    tag: "Living room repaint",
  },
  {
    id: "g2",
    after_url: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=1200&q=80&auto=format&fit=crop",
    title: "3 BHK · HSR Layout",
    tag: "Master bedroom",
  },
  {
    id: "g3",
    after_url: "https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?w=1200&q=80&auto=format&fit=crop",
    title: "1 BHK · Koramangala",
    tag: "Full apartment refresh",
  },
  {
    id: "g4",
    after_url: "https://images.unsplash.com/photo-1649083048381-520a5b3d91ff?w=1200&q=80&auto=format&fit=crop",
    title: "3 BHK · Indiranagar",
    tag: "Kids room + hall",
  },
];

function ProjectCard({ after_url, title, tag, index = 0 }) {
  return (
    <motion.div
      className="relative aspect-[4/3] rounded-2xl overflow-hidden hairline shadow-soft bg-white group"
      data-testid="gallery-card"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.85, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
    >
      <motion.img
        src={after_url}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
        initial={{ scale: 1.12 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        whileHover={{ scale: 1.05 }}
      />
      <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/70 to-transparent">
        {tag ? (
          <div className="text-white/80 text-[11px] font-bold uppercase tracking-widest">
            {tag}
          </div>
        ) : null}
        <div className="text-white font-display font-bold text-lg">{title}</div>
      </div>
    </motion.div>
  );
}

export default function Gallery() {
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    getGallery()
      .then((d) => d?.length && setItems(d))
      .catch(() => {});
  }, []);

  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal className="text-xs font-bold tracking-[0.22em] uppercase text-orange-600">Project gallery</Reveal>
            <Reveal as="h2" delay={0.05} className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-ink">
              Recent repaint projects across Bangalore.
            </Reveal>
            <Reveal delay={0.1} className="mt-4 text-ink-2">
              A snapshot of homes we&apos;ve repainted recently — from compact apartments to family villas.
            </Reveal>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {items.slice(0, 4).map((p, i) => (
            <ProjectCard key={p.id || p.title} {...p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
